"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatureMarketUSCADBachelor240OnlineDiscount = void 0;
const CountryTier_1 = require("../../../../definitions/CountryTier");
const BaseDiscount_1 = require("../../../BaseDiscount");
const Credits240Policy_1 = __importDefault(require("../../../../policies/Credits240Policy"));
const DeliveryMethodOnlinePolicy_1 = __importDefault(require("../../../../policies/DeliveryMethodOnlinePolicy"));
const EducationLevelBachelorPolicy_1 = __importDefault(require("../../../../policies/EducationLevelBachelorPolicy"));
const MatureUSCADCountryPolicy_1 = __importDefault(require("../../../../policies/MatureUSCADCountryPolicy"));
class MatureMarketUSCADBachelor240OnlineDiscount extends BaseDiscount_1.BaseDiscount {
    canHandle(criteria) {
        return MatureUSCADCountryPolicy_1.default.meets(criteria)
            && DeliveryMethodOnlinePolicy_1.default.meets(criteria)
            && EducationLevelBachelorPolicy_1.default.meets(criteria)
            && Credits240Policy_1.default.meets(criteria);
    }
    handle() {
        return {
            percentage: 6,
            basePrice: 25467,
            countryTier: CountryTier_1.CountryTier.MATURE
        };
    }
}
exports.MatureMarketUSCADBachelor240OnlineDiscount = MatureMarketUSCADBachelor240OnlineDiscount;
